import { Section } from "@/components/common";

export default function Privacy() {
  return (
    <Section className="py-12 sm:py-16 max-w-3xl">
      <p className="eyebrow mb-2">Privacy</p>
      <h1 className="font-display font-black text-4xl text-white mb-6">Privacy Policy</h1>
      <div className="card p-6 sm:p-8 space-y-5 text-slate-300 text-sm leading-relaxed">
        <p>DYORUSA collects only what you give us. For the newsletter, we require an email address and let you optionally choose a state or region, topics, and audience type. We do not require any other personal information.</p>
        <div>
          <h3 className="font-display font-bold text-white text-lg mb-2">What we store</h3>
          <p>Your signup date, consent status, selected audience and topics, confirmation status, and unsubscribe status.</p>
        </div>
        <div>
          <h3 className="font-display font-bold text-white text-lg mb-2">What we will never do</h3>
          <p>We do not sell or rent the subscriber list. We do not share your data with advertisers. Advertising is clearly labeled and never affects research findings.</p>
        </div>
        <div>
          <h3 className="font-display font-bold text-white text-lg mb-2">Your control</h3>
          <p>Every email includes a one-click unsubscribe link and a link to update your preferences. You can change your state, topics, or audience type at any time.</p>
        </div>
        <p className="text-slate-500 text-xs">Questions? Contact us via the <a href="/advertise" className="underline">inquiry form</a>.</p>
      </div>
    </Section>
  );
}
